"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remarkPayloadSchema = exports.remarkSchema = void 0;
var adjudication_comment_schema_1 = require("./adjudication-comment-schema");
exports.remarkSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    properties: {
        adjudicationComments: {
            type: ['array', 'null'],
            items: adjudication_comment_schema_1.adjudicationCommentSchema,
        },
        userComment: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 8000,
            errorMessage: 'Should be a string and have maximum of 8000 characters',
        },
    },
};
exports.remarkPayloadSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    anyOf: [{ required: ['adjudicationComment'] }, { required: ['userComment'] }],
    properties: {
        adjudicationComment: {
            type: 'object',
            additionalProperties: {
                not: true,
                errorMessage: '- should not have additional property ${0#}',
            },
            required: ['code', 'text', 'includeInLetterFlag', 'indexNumber'],
            properties: {
                code: {
                    type: 'string',
                    minLength: 6,
                    maxLength: 7,
                    errorMessage: 'Should be a string with 6 or 7 characters',
                },
                text: {
                    type: 'string',
                    minLength: 0,
                    maxLength: 500,
                    errorMessage: 'Should be a string and have maximum of 500 characters',
                },
                includeInLetterFlag: {
                    type: 'boolean',
                    errorMessage: 'should be true or false',
                },
                indexNumber: {
                    type: 'number',
                    minimum: 0,
                    maximum: 2147483647,
                    errorMessage: 'Should be an integer between 0 and 2147483647',
                },
            },
        },
        userComment: {
            type: 'string',
            minLength: 0,
            maxLength: 8000,
            errorMessage: 'Should be a string and have maximum of 8000 characters',
        },
    },
};
